<template>
  <div id="app-div">
    <a-config-provider :locale="locale">
      <router-view v-if="isRouterAlive"></router-view>
    </a-config-provider>
  </div>
</template>

<script>
import zhCN from "ant-design-vue/lib/locale-provider/zh_CN";
export default {
  name: "app",
  provide() {
    return {
      appReload: this.appReload,
    };
  },
  data() {
    return {
      collapsed: false,
      locale: zhCN,
      isRouterAlive: true,
    };
  },
  mounted() {
    window.addEventListener(
      "hashchange",
      () => {
        var currentPath = window.location.hash.slice(1); // 获取输入的路由
        if (this.$router.path !== currentPath) {
          this.$router.push(currentPath); // 动态跳转
        }
      },
      false
    );
  },
  methods: {
    appReload() {
      this.isRouterAlive = false;
      this.$nextTick(function () {
        this.isRouterAlive = true;
      });
    },
  },
};
</script>

<style scoped>
</style>
